import { render, staticRenderFns } from "./NumberInput2.vue?vue&type=template&id=4c2b5829"
import script from "./NumberInput2.vue?vue&type=script&lang=js"
export * from "./NumberInput2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports